import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nCurrencyTwo"
  }, [_vm.isShowKey ? _c('div', {
    staticClass: "nCurrencyTwo-btn",
    style: {
      background: _vm.itemBg
    }
  }, [_c('img', {
    ref: "TAPSTOCKRef",
    attrs: {
      "src": require(`@images/${_vm.theme}/lucky/key.png`),
      "alt": ""
    }
  }), _vm.userData && _vm.userData.hasOwnProperty('stock') ? _c('div', {
    staticClass: "nCurrencyTwo-btn__value"
  }, [_vm._v(_vm._s(_vm._f("fmt_pre")(_vm.userData.stock, 2, true, true)))]) : _vm._e(), _c('div', {
    staticClass: "nCurrencyTwo-btn-icon",
    on: {
      "click": function ($event) {
        !_vm.showkeyFnc ? _vm.$router.push('/earn') : _vm.showkeyFnc();
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-close"
    }
  })], 1)]) : _vm._e(), _vm.isShowCoin ? _c('div', {
    staticClass: "nCurrencyTwo-btn",
    style: {
      background: _vm.itemBg
    }
  }, [_c('img', {
    ref: "TAPCOINSRef",
    attrs: {
      "src": require(`@images/${_vm.theme}/lucky/tapcoins.png`),
      "alt": ""
    }
  }), _vm.userData && _vm.userData.hasOwnProperty('coin') ? _c('div', {
    staticClass: "nCurrencyTwo-btn__value"
  }, [_vm._v(_vm._s(_vm._f("fmt_pre")(_vm.userData.coin, 2, true, true)))]) : _vm._e(), _c('div', {
    staticClass: "nCurrencyTwo-btn-icon",
    on: {
      "click": function ($event) {
        !_vm.showCoinFnc ? _vm.$router.push('/mine') : _vm.showCoinFnc();
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-close"
    }
  })], 1)]) : _vm._e(), _vm.isShowTap ? _c('div', {
    staticClass: "nCurrencyTwo-btn",
    style: {
      background: _vm.itemBg
    }
  }, [_vm.tonCurrency.tap.icon ? _c('img', {
    ref: "TAPTAPRef",
    attrs: {
      "src": _vm.tonCurrency.tap.icon,
      "alt": ""
    }
  }) : _vm._e(), _vm.userData && _vm.userData.hasOwnProperty('coin') ? _c('div', {
    staticClass: "nCurrencyTwo-btn__value"
  }, [_vm._v(_vm._s(_vm._f("fmt_pre")(_vm.tonCurrency.tap.balance, 2, true, true)))]) : _vm._e(), _c('div', {
    staticClass: "nCurrencyTwo-btn-icon",
    on: {
      "click": function ($event) {
        !_vm.showTapFnc ? _vm.$router.push('/wallet') : _vm.showTapFnc();
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-close"
    }
  })], 1)]) : _vm._e(), _vm.isShowUsdt ? _c('div', {
    staticClass: "nCurrencyTwo-item"
  }, [_vm.tonCurrency.usdt.icon ? _c('img', {
    ref: "TAPUSDTRef",
    attrs: {
      "src": _vm.tonCurrency.usdt.icon,
      "alt": ""
    }
  }) : _vm._e(), _vm.userData && _vm.tonCurrency.usdt?.hasOwnProperty('balance') ? _c('div', {
    staticClass: "nCurrencyTwo-btn__value"
  }, [_vm._v(_vm._s(_vm._f("fmt_pre")(_vm.tonCurrency.usdt.balance, 3, true, true)))]) : _vm._e(), _c('div', {
    staticClass: "nCurrencyTwo-btn-icon",
    on: {
      "click": function ($event) {
        !_vm.showUsdtFnc ? _vm.$router.push('/wallet') : _vm.showUsdtFnc();
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-close"
    }
  })], 1)]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };